import api from './axiosApi'
import type {
  SkuSearchParams,
  SkuSearchResponse,
  SkuSearchResult,
} from '@/types/sku'

export type { SkuSearchResult, SkuSearchResponse }

/**
 * Search SKU catalog with full-text search
 * @param params - Search parameters
 * @returns Promise with search results
 */
export async function searchSkus(
  params: SkuSearchParams = {},
  signal?: AbortSignal
): Promise<SkuSearchResponse> {
  const {
    q,
    category,
    vendor_id,
    department,
    status,
    limit = 20,
    offset = 0,
  } = params

  const response = await api.get<SkuSearchResponse>('/skus/search', {
    params: {
      q: q || undefined,
      category,
      vendor_id,
      department,
      status,
      limit,
      offset,
    },
    signal,
  })

  return response.data
}
